import { Colors } from '@inplayer-org/inplayer-ui';

export const colors = [
  Colors.blue,
  Colors.turquoise,
  Colors.emerald,
  Colors.peterRiver,
  Colors.amethyst,
  Colors.orange,
  Colors.greenSea,
  Colors.nephritis,
  Colors.belizeHole,
  Colors.wisteria,
  Colors.amethyst,
  Colors.sunFlower,
  Colors.carrot,
  Colors.alizarin,
  Colors.pumpkin,
  Colors.pomegranate,
  Colors.concrete,
  Colors.asbestos,
];
